export const debuggingFeature = {
  ignoreDefaultEvent: false,
  consoleLog: false,
};
